import React, { Component } from 'react';
import { connect } from 'react-redux';
import {setDocumentFilter} from '../actions';
import '../global';

class DocumentFilter extends Component {

	filterDocumentType(event){
		this.props.setDocumentFilter('document_type',event.target.value);
	}

	getDocumentFilterValue(){
		return (typeof this.props.documentFilter.document_type !== 'undefined') ? this.props.documentFilter.document_type : '';
	}

	getDocumentTypes(){
		const documentTypeArr = ['General','Meeting Specific'];
		const documentOptions = documentTypeArr.map( documentType => (
			<option value={ documentType }>{ documentType }</option>
		) );
		documentOptions.unshift(<option value=''>All Documents</option>);
		return documentOptions;
	}

	render() {
			return (<div className="meeting-committee-options col-xs-12 col-md-3">
							<i className="fa-solid fa-filter"></i>
							 <select className="form-control" name="document-type-filter" onChange={this.filterDocumentType.bind(this)} value={this.getDocumentFilterValue()}>
								 {this.getDocumentTypes()}
							 </select>
							</div>);
		}
}

function mapStateToProps({documentFilter}) {
	return {documentFilter};
}

export default connect(mapStateToProps,{setDocumentFilter})(DocumentFilter);

